import React, { useState } from 'react';
// Interfaces
import { Input as InputInterface } from '../../../interfaces/form';
// Utils
import Translate from '../../../utils/translate';
// Icons
import ShowPassword from '../../../images/icons/view.svg';
import HidePassword from '../../../images/icons/view-off.svg';

function Input({ data, errors, register }: { data: InputInterface; errors: any; register: any }) {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const { id, type, placeholder, name, required, hidden, value, focused } = data;

  const validationHandler = (type: string) => {
    switch (type) {
      case 'textarea':
        return {
          value: value,
          required: {
            value: required,
            message: 'Field is required Textarea',
          },
          minLength: {
            value: 2,
            message: 'At least two characters are required',
          },
        };
      case 'text':
        return {
          value: value,
        };
      case 'tel':
        return {
          required: {
            value: required,
            message: 'Field is required',
          },
        };
      case 'email':
        return {
          required: {
            value: required,
            message: 'Field is required',
          },
          pattern: {
            value: /\S+@\S+\.\S+/,
            message: 'Entered value does not match email format',
          },
        };
      case 'password':
        return {
          required: {
            value: required,
            message: 'Field is required Password',
          },
          pattern: {
            value: /^(?=.*[A-Z])(?=.*\d.*\d).{8,}$/,
            message:
              'Must be at least 8 characters and contain at least one uppercase and two numbers',
          },
        };
      default:
        break;
    }
  };

  return (
    <div
      className={`${hidden ? 'cl-form-field--hidden' : 'cl-form-field'} ${
        errors[name]?.message ? 'cl-form-field--invalid' : ''
      }`}
    >
      {type === 'textarea' ? (
        <textarea
          type='text'
          {...register(name)}
          id={`id-${id}`}
          className='cl-form-field__input peer'
          name={name}
          hidden={hidden}
          required={required}
          autoFocus={focused}
          rows='3'
        />
      ) : (
        <input
          type={type === 'password' ? (passwordVisible ? 'text' : 'password') : type}
          {...register(name, validationHandler(type))}
          className='cl-form-field__input peer'
          id={`id-${id}`}
          hidden={hidden}
          required={required}
          autoFocus={focused}
          placeholder={placeholder}
          tabindex='-1'
        />
      )}

      {!hidden && (
        <label htmlFor={`id-${id}`} className='cl-form-field__label'>
          {placeholder}
        </label>
      )}

      {type === 'password' ? (
        <>
          <span
            onClick={() => setPasswordVisible(!passwordVisible)}
            className='cl-form-field__trailing-icon'
          >
            {passwordVisible ? (
              <img src={HidePassword} alt='hide' />
            ) : (
              <img src={ShowPassword} alt='show' />
            )}
          </span>
          <small
            className={
              errors[name]?.message
                ? 'cl-form-field__helper '
                : 'text-neutral-700 cl-form-field__helper'
            }
          >
            <span>
              *{' '}
              <Translate>
                Must be at least 8 characters and contain at least one uppercase and two numbers
              </Translate>
            </span>
          </small>
        </>
      ) : (
        errors[name]?.message && (
          <small className='cl-form-field__helper'>
            <span>
              * <Translate>{errors[name]?.message}</Translate>
            </span>
          </small>
        )
      )}
    </div>
  );
}

export default Input;
